import React, {Fragment} from 'react';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, Alert, Row, Col, Label, FormFeedback, Input} from 'reactstrap';

import {Utils} from "custom";
import {ClassroomIndividualAPI, ClassRoomInsideAPI, LeadLogAPI} from "api";

class EditPostIndividual extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id_post: null,
            message: null,
            loading: false,
            errors: false
        };
    }

    componentDidMount() {
        this.setState({id_post: this.props.preset.id, message: this.props.preset.message})
    }

    changeForm(text) {
        this.setState({message: text}, () => this.showModal());
    }

    resetForm() {
        // this.setState({
        //     logedit: {
        //         id:null,
        //         note:null
        //     },
        // }, () => {
            global.onSetModal({ isOpen: false });
        // });
    }

    showModal() {
        let errors = this.state.errors;
        global.onSetModal({
            title: this.props.label,
            content: <div>
                <Row>
                    <Col md="12">
                        <div className='mb-2'>
                            <Label className='form-label'>
                                Commento
                            </Label>
                            <textarea
                                className="form-control bg-light border-light"
                                value={this.state.message}
                                rows="3"
                                placeholder="Inserisci commento"
                                onChange={(e) => this.changeForm(e.target.value)}
                            >
                            </textarea>
                            {/* <Input type="tectarea" value={form.note}
                                   invalid={Boolean(errors.note)}
                                   onChange={(e) => this.changeForm('note', e.target.value)}/> */}
                            <FormFeedback>{errors.message}</FormFeedback>
                        </div>
                    </Col>

                </Row>
            </div>,
            isOpen: true,
            toggle: false,
            size: 'lg',
            type: 'info',
            buttons: [
                {label: 'SALVA', color: 'success', onClick: () => this.savePost()},
                {
                    label: 'CHIUDI',
                    color: 'danger',
                    onClick: () => this.resetForm()
                },
            ]
        })
    }



    savePost() {
        const self = this;
        let message = this.state.message;
        let error = {};

        if (message === '')
            error.message = "Il commento è obbligatorio";

        this.setState({errors: error}, () => this.showModal());

        if (Object.keys(error).length === 0) {
            global.onSetModal({loading: true});

            ClassroomIndividualAPI.editPostIndividual({
                id: this.state.id_post,
                message: message
            }).then(() => {
                global.onSetModal({loading: false});
                global.SweetAlert.fire({
                    title: 'Commento modificato',
                    text: 'Il commento è stato modificato correttamente.',
                    icon: 'success',
                    allowOutsideClick: false,
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    },
                    confirmButtonText: 'Chiudi',
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        self.props.onResolve();
                        self.resetForm()
                    }
                })
            }).catch(() => {
                global.onSetModal({loading: false});
                global.SweetAlert.fire({
                    title: 'Errore',
                    text: 'Si è verificato un errore durante la modifica del commento',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-primary'
                    }
                });
            })
        }
    }


    render() {
        return (
            <React.Fragment>
                <li className="list-inline-item cursor-pointer"
                    onClick={() => this.showModal()}>
                    <i className="ri-pencil-fill fs-20 text-info"></i>
                </li>
            </React.Fragment>
        )
    }
}

export default EditPostIndividual;
